import { isValidYoutubeUrl } from './youtubeUrl'

export interface LiveTvChannel {
  id: string
  title: string
  youtubeUrl: string
  enabled: boolean
  category?: 'football' | 'other'
  sortOrder?: number
}

export function parseLiveTvChannels(raw: unknown): LiveTvChannel[] {
  if (!Array.isArray(raw)) return []
  return raw
    .filter((item) => item && typeof item === 'object')
    .map((item) => item as LiveTvChannel)
    .filter((item) => item.id && item.title)
}

export function getActiveLiveTvChannels(channels: LiveTvChannel[]): LiveTvChannel[] {
  return channels
    .filter((channel) => channel.enabled !== false && isValidYoutubeUrl(channel.youtubeUrl))
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
}

export function hasActiveLiveTv(channels: LiveTvChannel[], liveTvEnabled?: boolean): boolean {
  if (liveTvEnabled === false) return false
  return getActiveLiveTvChannels(channels).length > 0
}
